import { useRive } from "@rive-app/react-canvas"

import Desert from "url:/public/assets/desert.riv"

const DesertAnimation = () => {
  const { RiveComponent } = useRive({
    src: Desert,
    stateMachines: "desert",
    autoplay: true,
  })
  return (
    <div css={{ width: 256, height: 256 }}>
      <RiveComponent />
    </div>
  )
}

export default DesertAnimation
